export const businessCentralOnPremConfiguration = {
  BusinessCentralOnPrem: `Business Central (On-Premises)`,
  "Connect to your Business Central api.": `Connect to your Business Central API`,
  business_central_on_prem_configurations: `Business Central (On-Premises) configurations`,
  businesscentral_onprem_output_connector: {
    userName: `Username`,
    password: `Password`,
    baseUrl: `Base URL`,
    environment: `Environment`,
  },
};
